const Footer = () => {


    return (
        <footer className="footer">
            <div className="footer-content">
               
              
            </div>
        </footer>
    );
};

export default Footer;